import React from 'react';

function UpgradeModal({
  open,
  usage,
  message,
  loading,
  checkoutError,
  onClose,
  onUpgrade,
  title,
  badge = 'Upgrade Required',
  actionLabel = 'Upgrade with Stripe',
  secondaryLabel = 'Maybe later',
}) {
  if (!open) {
    return null;
  }

  return (
    <div className="upgrade-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="upgrade-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="upgrade-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="upgrade-modal-badge">{badge}</div>
        <h2 id="upgrade-modal-title">{title || 'You reached your free redaction limit'}</h2>
        <p className="upgrade-modal-copy">
          {message || 'Your free plan includes 4 completed redacted exports. Upgrade to continue processing documents.'}
        </p>

        {usage && !usage.unlimited ? (
          <div className="upgrade-modal-usage">
            <span>{usage.used} used</span>
            <span>{usage.limit} total</span>
            <span>{usage.remaining} left</span>
          </div>
        ) : null}

        <div className="upgrade-plan-card">
          <strong>Pro plan</strong>
          <span>Unlimited redactions, continued access, and a smoother path for production use.</span>
        </div>

        {checkoutError ? (
          <div className="upgrade-modal-error" role="alert">
            {checkoutError}
          </div>
        ) : null}

        <div className="upgrade-modal-actions">
          <button className="hero-primary-btn" type="button" onClick={onUpgrade} disabled={loading}>
            {loading ? 'Redirecting...' : actionLabel}
          </button>
          <button className="hero-secondary-btn" type="button" onClick={onClose} disabled={loading}>
            {secondaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradeModal;
